import $ from 'jquery';
import ProductVariantColorSelect from '../../../components/product-variant-color-select';
export default class ProductTradeIn {
    static $button = $('.js__product-variant-color-select-button');
    static productVariantQueryParamKey = ProductTradeIn.$button.data('product-variant-query-param-key');
    static selectDeviceWrapperSelector = '.js__select-device-wrapper';
    static init() {
        this.$button.on('click', e => {
            window.location.assign(this.getUrl($(e.currentTarget).closest(this.selectDeviceWrapperSelector)));
        });
    }
    static getUrl($wrapper) {
        const baseUrl = $wrapper.find('.js__product-variant-color-select-button').data('base-url');
        return `${baseUrl}&${$.param({
            [this.productVariantQueryParamKey]: ProductVariantColorSelect.getSelectedProductVariant($wrapper),
        })}`;
    }
}
